<template>
  <div class="cobertura-holder">
    <div class="cobertura">
      <h2>ÁREA DE COBERTURA</h2>
      <div class="cobertura-content">
        <div>
          <div class="mapa">
            <img src="../assets/mapa.jpeg" alt="Mapa de cobertura" />
          </div>
        </div>
      </div>
      <div class="cobertura-atendimento">
        *Atendimento parcial, consultar disponibilidade para região.
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.cobertura-holder {
  width: 100%;
  background: rgb(249, 145, 56);
  background: radial-gradient(
    circle,
    rgba(249, 145, 56, 1) 0%,
    rgba(255, 114, 1, 1) 100%
  );
}

.cobertura {
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  // background: rgb(249, 145, 56);
  // background: radial-gradient(
  //   circle,
  //   rgba(249, 145, 56, 1) 0%,
  //   rgba(255, 114, 1, 1) 100%
  // );
  font-family: 'Red Hat Display';
  font-size: var(--font-size--large);
  padding-top: 2rem;
  padding-bottom: 4rem;
  h2 {
    font-family: 'Red Hat Display Bold';
    font-size: var(--font-size--super-large);
    color: #fff;
    width: 27rem;
    line-height: 4.5rem;
    margin: 4rem;
  }
  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-family: 'Red Hat Display';
    margin: 0 2rem;
    .mapa {
      position: relative;
      width: 100%;
      max-width: 100%;
      img {
        width: 100%;
        max-width: 100%;
        height: auto;
        display: block;
      }
    }
  }
  &-atendimento {
    color: #fff;
    display: flex;
    justify-content: center;
    padding: 0.25rem;
  }
  @media only screen and (max-width: 768px) {
    // font-size: 1.2rem;
    padding-top: 1.5rem;
    padding-bottom: 3rem;
    h2 {
      font-size: calc(var(--font-size--super-large) / 1.5);
      width: 24rem;
      line-height: 3.5rem;
      margin: 2rem;
    }
    &-content {
      margin: 0 1.5rem;
      .mapa {
        height: 420px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center center;
        }
      }
    }
  }

  @media only screen and (max-width: 520px) {
    // font-size: 0.8rem;
    font-size: var(--font-size--default);
    padding-top: 1rem;
    padding-bottom: 2rem;
    h2 {
      font-size: calc(var(--font-size--super-large) / 1.5);

      width: 18rem;
      line-height: 2.5rem;
      margin: 1rem;
    }
    &-content {
      margin: 0.5rem;
      .mapa {
        height: 320px;
      }
    }
  }
}
</style>
